import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Row } from 'react-bootstrap'
import { required } from '../../util/validationFunctions'
import ButtonChangeRecord from '../comun/button/ButtonChangeRecord'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from '../comun/form/InputSelect'
import {permisos as permisosConstant} from '../../constants/permisos'
import {modulos as modulosConstant} from '../../constants/modulos'

class ModalNivelGenetico extends Component {

  submitNuevaNivelGenetico (values) {
    if (this.props.data){
      this.props.actions.editarNivelGenetico(values)
    } else {
      this.props.actions.submitNuevaNivelGenetico(values)
    }
  }

  render () {
    const {
      t, handleSubmit, showModal, list, data, duplicar,
      actions: {recuperarDatosModalNivelGenetico, closeModal}
    } = this.props
    return (
      <Modal show={showModal} onHide={closeModal} aria-labelledby="contained-modal-title-lg" backdrop="static">
      <form className="form-nivel_genetico">
        <Modal.Header closeButton>
          <Modal.Title>
          {
            data ? (
              t('NIVEL_GENETICO.MODAL.TITULO_EDITAR')
            ) : (
              t('NIVEL_GENETICO.MODAL.TITULO_NUEVO')
            )
          }
          </Modal.Title>
          {data && data.id && (
            <ButtonChangeRecord list={list} idElemento="id" currentId={data.id} getNextRecord={recuperarDatosModalNivelGenetico} />
          )}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Field
              id="nombre"
              name="nombre"
              colSm={4}
              component={InputText}
              controlLabel={t('NIVEL_GENETICO.MODAL.NOMBRE') + '*'}
              claseActivo="nombre-nivel_genetico"
              validate={required}
              maxLength={true}
              valorMaxLength={20}
            />
            <Field
              id="prioridad"
              name="prioridad"
              colSm={4}
              component={InputText}
              controlLabel={t('NIVEL_GENETICO.MODAL.PRIORIDAD') + '*'}
              claseActivo="prioridad-nivel_genetico"
              validate={required}
              maxLength={true}
              valorMaxLength={50}
            />            
          </Row>
        </Modal.Body>
        <Modal.Footer>                    
          <Button
            type="button"
            onClick={this.props.submitSucceeded === false ? handleSubmit(this.submitNuevaNivelGenetico.bind(this)) : null}
            className={"btn btn-primary" + (this.props.submitSucceeded === true || (this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.NIVEL_GENETICO] < 2) ? ' disabled' : '')}
            disabled={(this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.NIVEL_GENETICO] < 2)}
          >{t('NIVEL_GENETICO.MODAL.GUARDAR')}</Button>
          <Button type="button" className="btn btn-white" onClick={closeModal}>{t('NIVEL_GENETICO.MODAL.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalNivelGenetico',
})(ModalNivelGenetico))